import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { Configuration } from './app.constants';
import { routing, appRoutingProviders } from './app.routes';
import { HttpModule, JsonpModule } from '@angular/http';
import { HomeComponent } from './home/home.component';
import { MainModule } from './main/main.module';
import { AppSettingsService } from './services/appsettings.service';
import { ProgressBarComponent } from './common/progressbar/progressbar.component'
import { ProgressBarService } from './services/progressbar.service'
import { DataTableModule, SharedModule } from 'primeng/primeng';
import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';

@NgModule({
    imports: [
        BrowserModule,
        HttpModule,
        JsonpModule,
        routing,
        DataTableModule,
        Ng2Bs3ModalModule,
        MainModule
    ],

    declarations: [AppComponent, HomeComponent, ProgressBarComponent],
    exports: [AppComponent, HomeComponent],
    providers: [
        appRoutingProviders,
        Configuration,
        AppSettingsService,
        ProgressBarService
    ],

    bootstrap: [AppComponent]
})
export class AppModule { }


/** WEBPACK FOOTER **
 ** ./app/app.module.ts
 **/